import styled from '@eduzz/houston-styles/styled';

interface IContainerProps {
  isClubeBlack: boolean;
}

export const Container = styled.div<IContainerProps>`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 10px 17px;
  user-select: none;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

  &:hover {
    background: ${props => (props.isClubeBlack ? '#2c2c2c' : '#11293f')};
    cursor: pointer;
  }
`;

export const ImgContainer = styled.div`
  width: 50px;
  height: 50px;

  img {
    height: 100%;
    border-radius: 50px;
  }
`;

export const UserInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  color: #fff;
  font-family: 'Lato', sans-serif;
  line-height: normal;
  p {
    text-transform: uppercase;
    margin: 0;
    padding: 0;
    font-size: 12px;
  }
  span {
    width: 8.5rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin: 0;
    padding: 0;
    font-size: 18px;
  }
`;
